"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MtaDeclineTextOutputWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment-timezone");
var HomeMtaDeclineText_1 = require("./HomeMtaDeclineText");
var react_router_dom_1 = require("react-router-dom");
var journey_model_1 = require("@athena-portal/journey-model");
var React = require("react");
var MtaDeclineTextOutputWidget = exports.MtaDeclineTextOutputWidget = /** @class */ (function (_super) {
    __extends(MtaDeclineTextOutputWidget, _super);
    function MtaDeclineTextOutputWidget(props) {
        return _super.call(this, props) || this;
    }
    MtaDeclineTextOutputWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-group declineTextWidget" },
                React.createElement("h1", null, "Your home policy will be cancelled"),
                React.createElement("div", { className: "panel" }, this.renderDeclineWording()),
                React.createElement("div", null, this.renderCancelPolicyButton()))));
    };
    MtaDeclineTextOutputWidget.prototype.renderDeclineWording = function () {
        var weekLater = moment().utc().add(7, "d");
        var currentEndDate = moment(this.props.interaction.headerInfo.endDate, moment.ISO_8601).utc();
        var declineEndDate = currentEndDate.isSameOrBefore(weekLater) ? currentEndDate.format("DD MMMM YYYY") : weekLater.format("DD MMMM YYYY");
        return (React.createElement(React.Fragment, null,
            this.getDeclineWording(),
            React.createElement("p", null,
                "Your home policy will end on ",
                declineEndDate,
                ", 23:59."),
            React.createElement("p", null,
                "Our friends at Gallaghers may be able to help you find the cover you need. Call them about their specialist insurance on:",
                ' ',
                React.createElement("a", { className: "text-decoration-underline text-blue-1", href: "tel:+44 333 188 7823", "aria-label": "Phone number +44 333 188 7823" }, "0333 188 7823"),
                "."),
            React.createElement("p", null,
                "Or visit",
                ' ',
                React.createElement("a", { className: "text-decoration-underline text-blue-1", href: "https://www.biba.org.uk/find-insurance/", target: "_blank" }, "BIBA.org.uk"),
                ' ',
                "to look for another suitable provider.")));
    };
    // TODO: need to understand what to do with soft declines, no requirements about that
    MtaDeclineTextOutputWidget.prototype.renderCancelPolicyButton = function () {
        var type = this.getSetting("process", undefined);
        var process = type === undefined ? "mtcForced" : "mtcForcedSupportPortal";
        return (React.createElement(react_router_dom_1.Link, { to: "/journey/init/product/AnnualHomeInsurance/process/".concat(process, "/presetPage/").concat(this.props.interaction._id), id: "cancelPolicy", className: "hard-decline-link-wrapper" },
            React.createElement("button", { type: "button", className: "btn btn-primary btn-next decline-cancel hard-decline" }, "Cancel policy")));
    };
    MtaDeclineTextOutputWidget.prototype.getDeclineWording = function () {
        if (this.props.interaction.underwritingResult.length > 1) {
            // TODO: FAL-31708 probably number of days needs to be dynamic based on policy expiry date
            return (React.createElement("p", null, "Thanks for letting us know about these changes. Unfortunately, this change in circumstances means we\u2019ll need to cancel your policy with effect from seven days, this is to give you time to find alternative insurance."));
        }
        else {
            for (var _i = 0, _a = new HomeMtaDeclineText_1.HomeMtaDeclineText().underwritingResultCustomerWordings; _i < _a.length; _i++) {
                var uw = _a[_i];
                if (uw.key === this.props.interaction.underwritingResult[0].objectName) {
                    return (React.createElement(React.Fragment, null,
                        uw.value,
                        uw.extraContent));
                }
            }
            return (React.createElement("p", null, "Unfortunately, this change means we\u2019ll need to cancel your policy with effect from seven days, this is to give you time to find alternative insurance."));
        }
    };
    MtaDeclineTextOutputWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "process", type: journey_model_1.TypeDescriptions.String },
        ]),
        __metadata("design:paramtypes", [Object])
    ], MtaDeclineTextOutputWidget);
    return MtaDeclineTextOutputWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=MtaDeclineTextOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/declineTextOutputWidget/MtaDeclineTextOutputWidget.js
// module id = 3668
// module chunks = 0